/* See each difference for yourself: the comparison strip on the collection pages
   (21 Sep 2026, Josh's brief).

   - Four buttons open one row across the three lights. The row opens and closes
     smoothly (grid rows 0fr to 1fr), and the three panels in a row are kept the
     same height so the lights line up.
   - The beam row is a photograph of the light on a page. A ring you turn narrows
     the pool of light and the lux figure climbs, exactly as the measured figures
     do (narrow is about twice wide at the same distance). A fixed beam has no ring.
   - The brightness row is the page itself. A thumbwheel dims it; a press-and-hold
     button climbs while it is held and falls when held again, and both remember
     where they were left.
   - The chooser's beam illustration (.cat-quiz-beam-help) is driven the same way. */
(function () {
  var FEATURES = ['beam', 'brightness', 'power', 'trial'];
  var sizingFrame = 0;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ Row heights */
  function grids() {
    return Array.prototype.slice.call(document.querySelectorAll('.cat-comparison-grid'));
  }
  function equalize() {
    grids().forEach(function (grid) {
      FEATURES.forEach(function (key) {
        var rows = Array.prototype.slice.call(grid.querySelectorAll('[data-feature="' + key + '"]'));
        if (!rows.length) return;
        if (!rows.some(function (row) { return !row.hidden; })) return;
        var summaryHeights = rows.map(function (row) {
          var summary = row.querySelector('.cat-feature-summary');
          if (!summary) return 0;
          summary.style.minHeight = '';
          return summary.getBoundingClientRect().height;
        });
        var summaryHeight = Math.ceil(Math.max.apply(null, [0].concat(summaryHeights)));
        rows.forEach(function (row) {
          var summary = row.querySelector('.cat-feature-summary');
          if (summary) summary.style.minHeight = summaryHeight + 'px';
        });
        var contentHeights = rows.map(function (row) {
          var panel = row.querySelector('.cat-feature-content');
          var inner = row.querySelector('.cat-feature-inner');
          if (!panel || !inner) return 0;
          var style = getComputedStyle(panel);
          return inner.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        });
        var height = Math.ceil(Math.max.apply(null, [0].concat(contentHeights)));
        rows.forEach(function (row) {
          var panel = row.querySelector('.cat-feature-content');
          if (panel) panel.style.minHeight = height + 'px';
        });
      });
    });
  }

  /* Every part of every column on the same line, whatever the copy length: the
     photograph, the figure, the control, the words, the facts. Each part takes the
     height of the tallest of its kind across the three lights, top to bottom. */
  var PARTS = ['.cat-feature-summary', '.cat-demo-photo', '.cat-demo-readout', '.cat-demo-controls', '.cat-feature-inner > p', '.cat-power-options', '.cat-trial-days', '.cat-trial-steps', '.cat-memory', '.cat-trial-keep'];
  function alignParts() {
    grids().forEach(function (grid) {
      FEATURES.forEach(function (key) {
        var rows = Array.prototype.slice.call(grid.querySelectorAll('[data-feature="' + key + '"]')).filter(function (row) { return !row.hidden; });
        if (rows.length < 2) return;
        PARTS.forEach(function (selector) {
          var parts = rows.map(function (row) { return row.querySelector(selector); });
          if (parts.some(function (el) { return !el; })) return;
          parts.forEach(function (el) { el.style.minHeight = ''; });
          var tallest = Math.max.apply(null, parts.map(function (el) { return el.getBoundingClientRect().height; }));
          parts.forEach(function (el) { el.style.minHeight = Math.ceil(tallest) + 'px'; });
        });
      });
    });
  }
  var equalizeCore = equalize;
  equalize = function () { alignParts(); equalizeCore(); };
  function scheduleSizing() {
    if (sizingFrame) return;
    sizingFrame = requestAnimationFrame(function () { sizingFrame = 0; equalize(); });
  }

  /* ---------------------------------------------------------- Open and close */
  function setFeature(comparison, key, quiet) {
    if (!comparison) return;
    var body = comparison.querySelector('.cat-comparison-body');
    // a switch still fading counts as made, so the next click is judged against it
    var current = comparison.dataset.pending || comparison.getAttribute('data-feature') || '';
    var opening = Boolean(key) && !current;
    var switching = Boolean(key) && current && key !== current;

    // The tabs pattern: the chosen tab is the only one in the tab order, and the body is the
    // panel it labels (22 Sep 2026 brief).
    function markTabs() {
      comparison.querySelectorAll('[data-compare-feature]').forEach(function (button) {
        var on = button.dataset.compareFeature === key;
        button.setAttribute('aria-selected', String(on));
        button.setAttribute('tabindex', on ? '0' : '-1');
        if (on && button.id && body) body.setAttribute('aria-labelledby', button.id);
      });
    }
    function show() {
      comparison.querySelectorAll('[data-feature]').forEach(function (panel) {
        panel.hidden = panel.dataset.feature !== key;
      });
      markTabs();
      if (key) comparison.setAttribute('data-feature', key); else comparison.removeAttribute('data-feature');
      equalize();
    }

    if (!body) { show(); return; }
    clearTimeout(comparison.switchTimer);
    delete comparison.dataset.pending;
    if (!key) {
      body.setAttribute('data-open', 'false');
      body.inert = true;
      comparison.removeAttribute('data-feature');
      comparison.querySelectorAll('[data-compare-feature]').forEach(function (b, i) { b.setAttribute('aria-selected', 'false'); b.setAttribute('tabindex', i === 0 ? '0' : '-1'); });
      var finish = function () { comparison.querySelectorAll('[data-feature]').forEach(function (p) { p.hidden = true; }); };
      if (reduced) finish(); else setTimeout(finish, 380);
      return;
    }
    if (switching && !reduced) {
      // The tabs change at once and only the last choice is shown when the fade ends, so a quick click back to the
      // tab just left is taken rather than ignored (whole-theme audit, 25 Sep 2026).
      markTabs();
      comparison.dataset.pending = key;
      body.classList.add('is-switching');
      comparison.switchTimer = setTimeout(function () { delete comparison.dataset.pending; show(); body.classList.remove('is-switching'); }, 160);
    } else {
      show();
    }
    body.inert = false;
    body.setAttribute('data-open', 'true');
    if (opening && !quiet) {
      // Bring the row into view if the buttons are near the bottom of the screen.
      var rect = comparison.querySelector('.cat-comparison-toolbar').getBoundingClientRect();
      if (rect.bottom > window.innerHeight - 160 || rect.top < 0) {
        comparison.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-compare-feature]');
    if (button) {
      var comparison = button.closest('.cat-comparison');
      // A segmented control: the chosen tab stays chosen, another tab switches the row.
      if (button.getAttribute('aria-selected') === 'true') return;
      setFeature(comparison, button.dataset.compareFeature);
      return;
    }
    var closer = event.target.closest('[data-close-comparison]');
    if (closer) setFeature(closer.closest('.cat-comparison'), null);
  });
  // The arrow keys move between the tabs and choose as they go; Home and End reach the ends.
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest ? event.target.closest('.cat-comparison [role="tab"]') : null;
    if (!tab) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab), next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    next.focus();
    if (next.getAttribute('aria-selected') !== 'true') setFeature(next.closest('.cat-comparison'), next.dataset.compareFeature);
  });

  /* ------------------------------------------------------------- The beam */
  // The pool of light on the page. Narrow is about half the width of wide and, as
  // the measured lux says, about twice as bright per unit of page.
  function poolFor(value) {
    var t = value / 100;                      // 0 narrow, 1 wide
    // A wider range than before (Josh, 22 Sep: the effect of the beam must be more visible):
    // the narrow pool is a tight column, the wide one reaches most of the page.
    return { w: 9 + 80 * t, h: 4 + 27 * t, glow: 1 - 0.5 * t };
  }
  function luxFor(demo, value) {
    var wide = Number(demo.dataset.luxWide || 0), narrow = Number(demo.dataset.luxNarrow || wide);
    return Math.round(narrow + (wide - narrow) * value / 100);
  }
  function describeBeam(value) { return value < 34 ? 'Narrow' : value > 66 ? 'Wide' : 'Medium'; }
  // The beam readout is about width, in words: the setting and what fits under it. The
  // words come from the section's labels on the demo; without them (the chooser's
  // illustration) the plain Narrow, Medium and Wide stand in.
  function beamWord(demo, value) { var d = demo.dataset; return value < 34 ? (d.wordNarrow || 'Narrow') : value > 66 ? (d.wordWide || 'Wide') : (d.wordMedium || 'Medium'); }
  function beamCovers(demo, value) { var d = demo.dataset; return value < 34 ? (d.coversNarrow || '') : value > 66 ? (d.coversWide || '') : (d.coversMedium || ''); }
  function setBeam(demo, value) {
    var fixed = demo.dataset.beamKind === 'fixed' || !demo.querySelector('[data-beam-range]');
    // A fixed beam sits at its own width: the HD Essential's is about 30cm across,
    // narrower than the Original and Pro at their widest.
    if (fixed) { value = Number(demo.dataset.beamFixed || 45); demo.style.setProperty('--fixed-pct', value + '%'); }
    var pool = poolFor(value);
    demo.style.setProperty('--pool-w', pool.w + '%');
    demo.style.setProperty('--pool-h', pool.h + '%');
    demo.style.setProperty('--pool-glow', pool.glow.toFixed(2));
    var word = fixed ? (demo.dataset.wordFixed || 'Fixed') : beamWord(demo, value);
    var covers = fixed ? (demo.dataset.coversFixed || '') : beamCovers(demo, value);
    var output = demo.querySelector('[data-beam-output]');
    if (output) output.textContent = word;
    var coversEl = demo.querySelector('[data-beam-covers]');
    if (coversEl) coversEl.textContent = covers;
    var control = demo.querySelector('[data-beam-range]');
    if (control) { control.value = value; control.setAttribute('aria-valuetext', word + (covers ? ', ' + covers.toLowerCase() : '')); }
    // The chooser's older illustration, if this demo is that one.
    var svgPool = demo.querySelector('[data-beam-pool]');
    if (svgPool) {
      var rx = 40 + 71 * value / 100, ry = rx * 0.36;
      svgPool.setAttribute('rx', rx); svgPool.setAttribute('ry', ry);
      var cone = demo.querySelector('[data-beam-cone]'), edge = demo.querySelector('[data-beam-edge]');
      if (cone) cone.setAttribute('d', 'M170 58 L' + (180 - rx) + ' 221 A' + rx + ' ' + ry + ' 0 0 0 ' + (180 + rx) + ' 221 L190 58Z');
      if (edge) edge.setAttribute('d', 'M170 58L' + (180 - rx) + ' 221M190 58L' + (180 + rx) + ' 221');
      if (output) output.textContent = describeBeam(value) + ' coverage';
    }
  }

  /* ---------------------------------------------------------- Brightness */
  function describeLevel(value) { return value < 34 ? 'Low' : value > 80 ? 'Full' : 'Medium'; }
  function setBrightness(demo, value) {
    value = Math.max(0, Math.min(100, value));
    // A light's full is its own full: 630 lumens sets the scale, so at full the
    // HD Essential's 500 lumens shows a little less light than the other two.
    var scale = Math.min(1, (Number(demo.dataset.lumens) || 630) / 630);
    // Low is properly low (Josh, 22 Sep: the effect of the brightness must be more visible).
    demo.style.setProperty('--level', ((0.05 + 0.95 * value / 100) * scale).toFixed(3));
    demo.style.setProperty('--level-pct', Math.round(value) + '%');
    demo.dataset.level = value;
    var output = demo.querySelector('[data-brightness-output]');
    if (output) output.textContent = describeLevel(value);
    // Brightness in lux on your page at 50cm: the light's own maximum (the narrow beam's
    // figure on an adjustable light, the one figure on a fixed one) at this level, to the
    // nearest hundred, with "Up to" in front where the width also moves it.
    var luxEl = demo.querySelector('[data-brightness-lux]'), luxWords = '';
    if (luxEl) {
      var max = Number(demo.dataset.luxMax) || 0;
      var lux = Math.round(max * (0.12 + 0.88 * value / 100) / 100) * 100;
      luxWords = (demo.dataset.luxPrefix ? demo.dataset.luxPrefix + ' ' : '') + lux.toLocaleString('en-GB');
      luxEl.textContent = luxWords;
    }
    var control = demo.querySelector('[data-brightness-range]');
    if (control) { control.value = value; control.setAttribute('aria-valuetext', describeLevel(value) + (luxWords ? ', ' + luxWords + ' lux' : '')); }
  }
  // Every light's brightness is a slider now (Josh, 21 Sep); the press-and-hold demo went.

  /* ------------------------------------------------------------- Wiring */
  function drawSection(section) {
    section.querySelectorAll('[data-beam-demo]').forEach(function (demo) {
      var control = demo.querySelector('[data-beam-range]');
      setBeam(demo, control ? Number(control.value) : 100);
    });
    section.querySelectorAll('[data-brightness-demo]').forEach(function (demo) {
      var control = demo.querySelector('[data-brightness-range]');
      setBrightness(demo, control ? Number(control.value) : Number(demo.dataset.level || 100));
    });
  }
  document.addEventListener('input', function (event) {
    if (!event.target.matches) return;
    var section = event.target.closest('.cat-comparison') || event.target.closest('.cat-quiz-beam-help') || event.target.closest('.cat-signature');
    if (!section) return;
    if (event.target.matches('[data-beam-range]')) {
      var value = Number(event.target.value);
      // Each light's ring turns its own beam (Josh, 22 Sep 2026: the HD Original and HD Pro
      // move independently). The HD Essential's beam is fixed, so it has no ring.
      var beamDemo = event.target.closest('[data-beam-demo]');
      if (beamDemo) setBeam(beamDemo, value);
      return;
    }
    if (event.target.matches('[data-brightness-range]')) {
      var v = Number(event.target.value);
      // Each light's slider dims its own page (Josh, 22 Sep 2026), the HD Essential's included.
      var brightDemo = event.target.closest('[data-brightness-demo]');
      if (brightDemo) setBrightness(brightDemo, v);
    }
  });

  function init() {
    document.querySelectorAll('.cat-comparison, .cat-quiz-beam-help, .cat-signature').forEach(drawSection);
    // The first tab is shown from the start on a desktop, without scrolling anything. On a phone
    // the comparison stays closed until a tab is chosen (Josh, 22 Sep): it is a lot of page there.
    var wide = !window.matchMedia || window.matchMedia('(min-width: 761px)').matches;
    document.querySelectorAll('.cat-comparison[data-default]').forEach(function (comparison) {
      if (wide && !comparison.getAttribute('data-feature') && comparison.dataset.default) setFeature(comparison, comparison.dataset.default, true);
    });
    // A closed comparison keeps its first tab in the keyboard order, so it can be opened from the keyboard (whole-theme
    // audit, 25 Sep 2026: on a phone all four tabs started out of the tab order and Tab skipped straight past them).
    document.querySelectorAll('.cat-comparison').forEach(function (comparison) {
      if (comparison.getAttribute('data-feature')) return;
      comparison.querySelectorAll('[data-compare-feature]').forEach(function (b, i) { b.setAttribute('tabindex', i === 0 ? '0' : '-1'); });
    });
    equalize();
    if (typeof ResizeObserver !== 'undefined') {
      if (init.observer) init.observer.disconnect();
      var observer = (init.observer = new ResizeObserver(scheduleSizing));
      document.querySelectorAll('.cat-feature-inner').forEach(function (inner) { observer.observe(inner); });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleSizing);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', scheduleSizing);
})();
